<!--
 * @Author: DY
 * @Date: 2020-06-20 14:57:00
 * @LastEditTime: 2021-10-16 11:43:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\salesComponents\FormView.vue
-->
<template>
    <v-touch
        @swiperight="swiperright"
        @pinchout="pinchout"
        @pinchin="pinchin"
        class="wrapper"
    >
        <div class="form-view">
            <van-nav-bar
                title="表单预览"
                left-text="返回"
                left-arrow
                v-if="isNews != true"
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <iframe
                    :src="src"
                    frameborder="0"
                ></iframe>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 表单缩放
    name: 'form-view',
    components: {},
    props: {},
    data() {
        return {
            token: '',
            // 合同审批页面传入token
            newsToken: '',
            src: '',
            // 表单参数
            formData: {},
            // 审批数据
            approvalData: {},
            // 是否是消息跳转审批
            isNews: false,

        };
    },
    computed: {},
    watch: {},
    created() {
        this.isNews = this.$route.params.isNews;
        this.formData = this.$route.params.formData;
        this.newsToken = this.$route.params.thisToken;
        this.approvalData = this.$route.params.approvalData;
        if ((this.newsToken || '') !== '') {
            this.token = this.newsToken;
        } else {
            this.token = window.localStorage.getItem('token');
        }
        this.src = '' + this.GLOBAL.FORM_BASE_URL + 'angularForm/FormView.html?FormCode=' + this.formData.FormCode + '&';
        this.src += 'frameId=' + this.formData.FormId + '&';
        this.src += 'FormUseInJiYunFlow=true&';
        if (this.formData.FormKeyValue) {
            this.src += 'PKValues=' + this.formData.FormKeyValue + '&';
        }
        this.src += 'IsView=true&';
        this.src += 'businessInstanceId=' + this.approvalData.BusinessInstanceId + '&';
        this.src += 'DeviceType=2&';
        this.src += 'token=' + this.token;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        pinchout() {
            alert(2);
        },
        pinchin() {
            alert(3);
        },
    },
};
</script>
<style lang="stylus" scoped>
.form-view
    height 100%
    section
        height calc(100% - 45rpx)
        overflow hidden
        iframe
            width 100%
            height 100%
</style>


